import Image from 'next/image'
import Link from 'next/link'
import React, { memo } from 'react'
import LabelCard from './LabelCard'

interface Props {
  className?: string
  title?: string
  categoryName?: string
  categoryId?: string
  imageUrl?: string
  link?: string
  isLoading?: boolean
  isImage?: boolean // Thêm props mới
}

const HeroCard: React.FC<Props> = ({
  className = '',
  title = '',
  categoryName = '',
  categoryId = '',
  imageUrl = '',
  link = '#',
  isLoading = false,
  isImage = true, // Mặc định là true
}) => {
  return (
    <article>
      {isLoading ? (
        // Skeleton loading state
        <div className="animate-pulse">
          {isImage && <div className="w-full h-[200px] bg-gray-300 rounded" />}
          <div className="p-4">
            <div className="h-6 bg-gray-300 rounded w-3/4 mb-2" />
            <div className="h-4 bg-gray-300 rounded w-1/2" />
          </div>
        </div>
      ) : (
        // Normal HeroCard content
        <Link href={`/${link}`} className={className}>
          {/* Hiển thị hình ảnh và LabelCard nếu isImage là true */}
          {isImage && (
            <div className="relative mx-auto w-full h-[200px]">
              <Image
                src={`${process.env.NEXT_PUBLIC_IMAGE_URL}${imageUrl}`}
                alt={title || 'title '}
                title={title}
                fill
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 680px"
                className="object-cover"
                priority
                unoptimized
              />
              <LabelCard categoryId={categoryId} categoryName={categoryName} />
            </div>
          )}

          {/* Tiêu đề */}
          <div className="p-4">
            <h3 className="text-black font-title font-semibold hover:text-primary" title={title}>
              {title}
            </h3>
          </div>
        </Link>
      )}
    </article>
  )
}

export default memo(HeroCard)
